import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { Globals } from 'src/shared/globals';
import { NiceScrollService } from '../_services/nice-scroll.service';
import { ChosenSelectService } from '../_services/chosen-select.service';
import { SearchTypeService } from '../_services/search/search-type.service';
import { CommonService } from '../_services/listing/common.service';
import { PropertiesService } from 'src/services/Properties';
import { Title } from '@angular/platform-browser';
import { PropertySearchModel, Select2Data } from 'src/model/Property_Search/PropertySearch';
import { HomeService } from 'src/services/Home';
import { NgSelectComponent } from '@ng-select/ng-select';
import { trigger, transition, useAnimation } from '@angular/animations';
// import { bounce, flipInX } from 'ng-animate';
import { ToasterService } from '../_services/toaster.service';
import { CanonicalService } from '../shared/canonical.service';
declare var $: any;

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-Properties',
    templateUrl: './Properties.html',
    styleUrls: ['./Properties.css'],
    standalone: false
})
export class PropertiesComponent implements OnInit, AfterViewInit {
  scrollUp: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private chosenSelect: ChosenSelectService,
    private searchType: SearchTypeService,
    private commonService: CommonService,
    private PropertyService: PropertiesService,
    private titleService: Title,
    private propertySearch: PropertySearchModel,
    private canonicalService: CanonicalService,
    private toasterService: ToasterService,
    private niceScroll: NiceScrollService

  ) {
    niceScroll.scrollToTop();
  }

  PropertyCities: Array < any > = [{ Id: 0, Text: 'All Cities' }];
  AllPropertyLocations: Array < any > = [{ CityId: 0, Id: 0, Text: 'All Locations' }];
  PropertyLocations: Array < any > = [{ CityId: 0, Id: 0, Text: 'All Locations' }];
  AreaUnits: Array < any > = [];
  PropertyTypes: Array < any > = [];
  Areas: Array < Select2Data > = [];
  BedRooms: Array < any > = [];
  BathRooms: Array < any > = [];
  Locations: Array < any > = [];
  // Pagination...!!
  collection = { count: 0, data: [] };
  isProcessed = false;
  isLocationFilterApplied = false;
  IsHomeCategory = true;

  public maxSize = 7;
  public directionLinks = true;
  public autoHide = false;
  public responsive = true;

  /* Search Filter Properties */

  public Purpose = 0;
  public City = 0;
  Keywords;
  PropertyType;
  MinPrice;
  MaxPrice;
  AreaUnit;
  MinArea;
  MaxArea;
  BedRoom;
  BathRoom;
  // OtherFeature;

  @ViewChild('CityDropdown')
   CityDropdown: NgSelectComponent;

  public Params: Params;

  IsLoading = false;
  ngOnInit() {
    this.titleService.setTitle('Search Property | Buy, Sell, Rent Homes & Properties in Pakistan | pakmatti.com');
    this.canonicalService.setCanonicalURL();
    this.SetParameters();
    this.PopulateDropdown();
  }


  SetParameters() {
    this.IsLoading = true;
    if (this.route.snapshot.queryParams.City) {
      this.route.queryParams.subscribe(params => {
        this.Params = params;
        this.propertySearch.Purpose = params.Purpose;
        this.propertySearch.City = params.City;
        this.propertySearch.Location = params.Location;
        this.propertySearch.Keywords = params.Keywords;
        this.propertySearch.PropertyType = params.PropertyType;
        this.propertySearch.MinPrice = params.MinPrice;
        this.propertySearch.MaxPrice = params.MaxPrice;
        this.propertySearch.AreaUnit = params.AreaUnit;
        this.propertySearch.MinArea = params.MinArea;
        this.propertySearch.MaxArea = params.MaxArea;
        this.propertySearch.BedRooms = params.BedRooms;
        this.propertySearch.BathRooms = params.BathRooms;
      });
      const body = JSON.stringify(this.propertySearch);
      this.PropertyService.SearchPropertyService(body).subscribe(data => {
        this.collection.count = data.length;
        this.collection.data = data;
        this.isProcessed = true;
        this.commonService.GridLayoutSwitcher();
        this.IsLoading = false;
      });
    } else {
      this.isLocationFilterApplied = true;
      this.Locations = [];
      this.Purpose = 0;
      this.City = 0;
      this.Locations.push(0);
      // this.PropertyType = 1;
      // this.AreaUnit = 2;
      this.propertySearch.Purpose = '0';
      this.propertySearch.City = 0;
      this.propertySearch.Keywords = '';
      this.propertySearch.PropertyType = 0;
      this.propertySearch.AreaUnit = 0;
      this.propertySearch.Location = '';
      this.propertySearch.MinPrice = '';
      this.propertySearch.MaxPrice = '';
      this.propertySearch.MinArea = '';
      this.propertySearch.MaxArea = '';
      this.propertySearch.BedRooms = '';
      this.propertySearch.BathRooms = '';
      const body = JSON.stringify(this.propertySearch);
      this.PropertyService.SearchPropertyService(body).subscribe(data => {
        this.collection.count = data.length;
        this.collection.data = data;
        this.isProcessed = true;
        this.commonService.GridLayoutSwitcher();
        this.IsLoading = false;
      });
    }
  }

  ngAfterViewInit() {
    this.commonService.GridLayoutSwitcher();
    this.chosenSelect.Render();
    this.searchType.Render();
  }

  PopulateDropdown(): void {
    const endPoint = 'GetDropDownData';
    this.PropertyService.GetService(endPoint).subscribe(data => {
      this.PropertyCities = data.Cities;
      // this.AllPropertyLocations = data.Locations;
      this.PropertyTypes = data.Types;
      this.AreaUnits = data.AreaUnits;
      this.BedRooms = data.BedRooms;
      this.BathRooms = data.BathRooms;
      if (this.route.snapshot.queryParams.Purpose) {
        this.SetValues();
      }
    });
  }

  SetValues() {
    this.Purpose = this.Params.Purpose;
    this.City = parseInt(this.Params.City, 10);
    this.cityLocations();
    this.PropertyType = parseInt(this.Params.PropertyType, 10);
    this.AreaUnit = parseInt(this.Params.AreaUnit, 10);
    if (this.Params.MinArea !== undefined || this.Params.MinArea != null) {
      this.MinArea = this.Params.MinArea;
    }
    if (this.Params.MaxArea !== undefined || this.Params.MaxArea != null) {
      this.MaxArea = this.Params.MaxArea;
    }
    if (this.Params.MinPrice !== undefined || this.Params.MinPrice != null) {
      this.MinPrice = this.Params.MinPrice;
    }
    if (this.Params.MaxPrice !== undefined || this.Params.MaxPrice != null) {
      this.MaxPrice = this.Params.MaxPrice;
    }
    if (this.Params.BedRooms !== undefined || this.Params.BedRooms != null) {
      this.BedRoom = parseInt(this.Params.BedRooms, 10);
    }
    if (this.Params.BathRooms !== undefined || this.Params.BathRooms != null) {
      this.BathRoom = parseInt(this.Params.BathRooms, 10);
    }
  }

  onRadioItemChange(value: number) {
    this.Purpose = value;
  }




  setLocations() {
    this.Locations = [];
    // tslint:disable-next-line: triple-equals
    if (this.Params != undefined && this.Params.Location != undefined) {
      const LocationParam = this.Params.Location;
      if (LocationParam.includes(',')) {
        const LocationsIDs = LocationParam.split(',');
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < LocationsIDs.length; i++) {
          this.Locations.push(parseInt(LocationsIDs[i], 10));
        }
      } else if (LocationParam.length > 0) {
        this.Locations.push(parseInt(LocationParam, 10));
      }
    }
  }

  cityLocations() {
    // tslint:disable-next-line: triple-equals
    if (this.City != null && this.City != 0) {
      this.PropertyService.getLocationsByCityId(this.City).subscribe(locations => {
        this.PropertyLocations = locations;
        this.Locations = [];
        if (locations.length === 1) {
          this.Locations.push(locations[0].Id);
        } else if (this.City === 0) {
          this.PropertyLocations = this.AllPropertyLocations;
          this.Locations = [];
          this.Locations.push(0);
        }
        if (!this.isLocationFilterApplied) {
          this.setLocations();
          this.isLocationFilterApplied = true;
        }
      });
      // tslint:disable-next-line: triple-equals
    } else if (this.City == 0) {
      this.PropertyLocations = this.AllPropertyLocations;
      this.Locations = [];
      this.Locations.push(0);
    } else {
      this.PropertyLocations = this.AllPropertyLocations;
      this.Locations = [];
    }
  }

  PropertyTypeChange(){
    if(this.PropertyType !== null){
      var propertyType = this.PropertyTypes[this.PropertyType];
      if(propertyType !== undefined && propertyType !== null && (propertyType.SubType === "HOMES" || propertyType.SubType === null)){
        this.IsHomeCategory = true;
    }else{
      this.IsHomeCategory = false;
     this.BedRoom = null;
     this.BathRoom = null;
    }
  }else{
    this.IsHomeCategory = true;
  }
}


  PriceORAreaOnChange(Param: string) {
    if (Param === 'Area') {
      if (this.MaxArea !== undefined && this.MinArea !== undefined) {
        // tslint:disable-next-line: radix
        if (parseInt(this.MinArea.replace(/,/g, '')) > parseInt(this.MaxArea.replace(/,/g, ''))) {
          // tslint:disable-next-line: max-line-length
          this.toasterService.Warning('Min area should be less than or equal to max area.', 'Search may not work properly, please fix the below warning!');
        }
      }
    }
    if (Param === 'Price') {
      if (this.MaxPrice !== undefined && this.MinPrice !== undefined) {
        // tslint:disable-next-line: radix
        if (parseInt(this.MinPrice.replace(/,/g, '')) > parseInt(this.MaxPrice.replace(/,/g, ''))) {
          // tslint:disable-next-line: max-line-length
          this.toasterService.Warning('Min price should be less than or equal to max price.', 'Search may not work properly, please fix the below warning!');
        }
      }
    }
  }

  SearchProperty() {debugger;
    this.IsLoading = true;
    this.propertySearch.Purpose = this.Purpose;
    if (this.City != null && this.City !== undefined) {
      this.propertySearch.City = this.City;
    } else {
      this.propertySearch.City = 0;
    }
    if (this.Locations != null && this.Locations !== undefined) {
      this.propertySearch.Location = this.Locations.join(',');
    } else {
      this.propertySearch.Location = '';
    }

    if(this.Keywords != null && this.Keywords !== undefined){
      this.propertySearch.Keywords = this.Keywords;
    }else{
      this.propertySearch.Keywords = this.Keywords;
    }


    if (this.PropertyType != null && this.PropertyType !== undefined) {
      this.propertySearch.PropertyType = this.PropertyType;
    } else {
      this.propertySearch.PropertyType = 0;
    }

    if (this.MinPrice != null && this.MinPrice !== undefined) {
      this.propertySearch.MinPrice = this.MinPrice.toString();
    } else {
      this.propertySearch.MinPrice = '';
    }


    if (this.MaxPrice != null && this.MaxPrice !== undefined) {
      this.propertySearch.MaxPrice = this.MaxPrice.toString();
    } else {
      this.propertySearch.MaxPrice = '';
    }

    if (this.AreaUnit != null && this.AreaUnit !== undefined) {
      this.propertySearch.AreaUnit = this.AreaUnit;
    } else {
      this.propertySearch.AreaUnit = 0;
    }

    if (this.MinArea != null && this.MinArea !== undefined) {
      this.propertySearch.MinArea = this.MinArea.toString();
    } else {
      this.propertySearch.MinArea = '';
    }

    if (this.MaxArea != null && this.MaxArea !== undefined) {
      this.propertySearch.MaxArea = this.MaxArea.toString();
    } else {
      this.propertySearch.MaxArea = '';
    }

    if (this.BedRoom != null && this.BedRoom !== undefined) {
      this.propertySearch.BedRooms = this.BedRoom.toString();
    } else {
      this.propertySearch.BedRooms = '';
    }

    if (this.BathRoom != null && this.BathRoom !== undefined) {
      this.propertySearch.BathRooms = this.BathRoom.toString();
    } else {
      this.propertySearch.BathRooms = '';
    }
    const body = JSON.stringify(this.propertySearch);
    this.PropertyService.SearchPropertyService(body).subscribe(data => {
      this.collection.count = data.length;
      this.collection.data = data;
      this.commonService.GridLayoutSwitcher();
      this.IsLoading = false;
      $('html, body').animate({
        scrollTop: $('#container-listing').offset().top - 100
      }, 1000);
    });
  }
}
